import React ,{ forwardRef } from "react";

const Video = forwardRef(({className='', ...props},ref)=>(
    <video
        ref={ref}
        className={className}
        {...props}
    />
))
export default Video